import { ReactElement } from "react";
import { TooltipProps } from "recharts";
import { Paper, Stack, Text } from "@mantine/core";
import { formatNumber, Group, labelToDataId } from "@flexidao/ui-lib";
import { Units } from "@flexidao/dto";

export const CustomTooltip = ({
    label,
    payload,
    numDecimals,
    units,
}: TooltipProps<number, string> & {
    numDecimals: number;
    units: Units;
    visibleKeys: Set<string>;
}): ReactElement => {
    return (
        <Paper
            sx={{
                zIndex: 1000,
            }}
            shadow="xl"
            data-id="chart--tooltip"
        >
            <Stack>
                <Text data-id="bar-chart-tooltip--label" weight="bold" size="md" c="flexidaoGrey.7">
                    {label}
                </Text>

                {payload?.map(({ name, value, color, dataKey }): ReactElement => {
                    console.log(dataKey);

                    const dataId = labelToDataId({
                        prefix: "tooltip-item",
                        label: name ?? "",
                    });

                    const formattedNumber: string = formatNumber(value ?? null, {
                        numDecimals,
                    });

                    const integerPart: string = formattedNumber?.split(".")[0] ?? "";
                    const decimalPart: string | null = formattedNumber?.split(".")[1] ?? null;

                    return (
                        <Group
                            key={dataId}
                            data-id={dataId}
                            spacing="16px"
                            noWrap
                            sx={{
                                display: "flex",
                                justifyContent: "space-between",
                                width: "100%",
                            }}
                        >
                            <Group
                                spacing={4}
                                data-id={labelToDataId({
                                    prefix: dataId,
                                    label: "label",
                                })}
                            >
                                <svg width={12} height={12}>
                                    <circle fill={color} r={6} cx={6} cy={6} />
                                </svg>

                                <Text size="14px">{name}:</Text>
                            </Group>

                            <Group
                                spacing={4}
                                align="baseline"
                                noWrap
                                data-id={labelToDataId({
                                    prefix: dataId,
                                    label: "value",
                                })}
                            >
                                <Group spacing={0} align="baseline" noWrap>
                                    <Text size="14px" fw="bold">
                                        {integerPart}
                                    </Text>

                                    {decimalPart && (
                                        <Text size="11px" fw="bold">
                                            .{decimalPart}
                                        </Text>
                                    )}
                                </Group>

                                {value != null && (
                                    <Text size="11px" fw="bold">
                                        {units}
                                    </Text>
                                )}
                            </Group>
                        </Group>
                    );
                })}
            </Stack>
        </Paper>
    );
};
